import React from 'react';
import { applyVisibilityRule, StateVisibilityRule } from '@app/common';
import { createAndSaveEvent } from '../../services/EventLoggingService/EventLoggingService';
import { babyBorn } from '../../store/globalStateSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import ConfirmPopup from './ConfirmPopup';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const visibilityRule: StateVisibilityRule = {
    showIf: ['PREGNANCY'],
    hideIf: [],
};

const BabyBornHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const dispatch = useAppDispatch();
    const stateProperties = useAppSelector(state => state.globalState.user?.stateProperties || []);
    const user = useAppSelector(state => state.globalState.user);

    const [showConfirmPopup, setShowConfirmPopup] = React.useState<boolean>(false);
    const [showInfoDialog, setShowInfoDialog] = React.useState<boolean>(false);

    const disabled = !applyVisibilityRule(visibilityRule, stateProperties);

    const babyBornClicked = () => {
        setShowConfirmPopup(true);
    };

    const babyIsReallyBorn = () => {
        setShowConfirmPopup(false);
        dispatch(babyBorn());
        createAndSaveEvent(user?.code, 'baby-born');
        setShowInfoDialog(true);
    };

    const babyBornButtonProps: HomeScreenButtonProps = {
        label: customLabel || 'Mein Baby ist da!',
        iconPath: 'baby-boy.png',
        customIconSvg: customIcon
    };

    return (
        <>
            <HomeScreenButton
                buttonProps={babyBornButtonProps}
                action={babyBornClicked}
                isHidden={false}
                disabled={disabled}
            />
            {showConfirmPopup && <ConfirmPopup 
                title="Herzlichen Glückwunsch"
                text="Wenn Du auf OK klickst, ändern sich die Vorschläge in der App und Dir werden die Übungen empfohlen, die für die Zeit nach der Geburt relevant sind. Du kannst Dir weiterhin die anderen Inhalte anschauen und Deine Eingaben werden gespeichert."
                dismissLabel="Abbrechen"
                confirmLabel="OK"
                onDismissClicked={() => setShowConfirmPopup(false)}
                onConfirmClicked={babyIsReallyBorn}
            />}
            {showInfoDialog && <ConfirmPopup 
                title="Herzlichen Glückwunsch"
                text="Dir werden von nun an die Inhalte für die Zeit nach der Geburt empfohlen."
                confirmLabel="OK"
                onConfirmClicked={() => setShowInfoDialog(false)}
            />}
        </>
    );
};
export default BabyBornHomeScreenButton;